import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

/** Редирект со старых URL на hub с вкладкой (?tab=). */
export function AdminTabRedirect({ basePath, tab, preserve = [] }) {
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams();
  next.set('tab', tab);
  preserve.forEach((key) => {
    const value = searchParams.get(key);
    if (value) next.set(key, value);
  });
  return <Navigate to={`/admin${basePath}?${next.toString()}`} replace />;
}
